import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  ToggleButton, 
  ToggleButtonGroup, 
  useTheme,
  alpha,
  Fade
} from '@mui/material';
import { 
  CalendarMonth, 
  Web,
  AutoAwesome
} from '@mui/icons-material';
import SmartStartBookingHero from './SmartStartBookingHero';
import SmartStartWebsiteHero from './SmartStartWebsiteHero';
import { logFunnelEvent } from '../../firebase/analytics';

const SmartStartHub = () => {
  const theme = useTheme();
  const [activeDemo, setActiveDemo] = useState('booking');

  const handleDemoChange = (event, newDemo) => {
    if (newDemo !== null) {
      setActiveDemo(newDemo);
      logFunnelEvent('demo_toggle', { demo: newDemo });
    }
  };

  return (
    <Box sx={{ position: 'relative', pt: 10 }}>
      {/* Toggle Controls */}
      <Container maxWidth="md" sx={{ textAlign: 'center', mb: 0, position: 'relative', zIndex: 10 }}>
        <Box 
          sx={{ 
            display: 'inline-flex', 
            flexDirection: 'column',
            alignItems: 'center',
            p: 1,
            borderRadius: 4,
            background: 'rgba(255, 255, 255, 0.03)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
          }}
        >
          <Typography 
            variant="caption" 
            sx={{ 
              color: theme.palette.text.secondary, 
              fontWeight: 700, 
              textTransform: 'uppercase', 
              letterSpacing: 1.5,
              mb: 1.5,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              fontSize: '0.7rem'
            }}
          >
            <AutoAwesome sx={{ fontSize: 14, color: theme.palette.primary.main }} />
            Configure Your AI Manager
          </Typography>

          <ToggleButtonGroup
            value={activeDemo}
            exclusive
            onChange={handleDemoChange}
            sx={{
              gap: 1,
              '& .MuiToggleButtonGroup-grouped': {
                border: 0,
                borderRadius: '10px !important',
                mx: 0.5,
                px: { xs: 2, md: 4 },
                py: 1,
                color: theme.palette.text.secondary,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: { xs: '0.8rem', md: '0.95rem' },
                transition: 'all 0.2s ease',
                '&.Mui-selected': {
                  background: 'rgba(255, 255, 255, 0.05)',
                  color: '#ffffff',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
                  '&:hover': {
                    background: 'rgba(255, 255, 255, 0.08)',
                  }
                },
                '&:hover': {
                  background: 'rgba(255, 255, 255, 0.02)',
                }
              }
            }}
          >
            <ToggleButton value="booking">
              <CalendarMonth sx={{ mr: 1, fontSize: 18 }} />
              Booking System
            </ToggleButton>
            <ToggleButton value="website">
              <Web sx={{ mr: 1, fontSize: 18 }} />
              Full Website
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Container>

      {/* Hero Content */}
      <Box sx={{ position: 'relative', mt: { xs: -4, md: -8 } }}>
        {activeDemo === 'booking' ? (
          <Fade in timeout={800}>
            <Box>
              <SmartStartBookingHero />
            </Box>
          </Fade>
        ) : (
          <Fade in timeout={800}>
            <Box>
              <SmartStartWebsiteHero />
            </Box>
          </Fade>
        )}
      </Box>
    </Box>
  );
};

export default SmartStartHub;
